export default "__VITE_ASSET__298a0834__"